import { apolloClient } from '~/apollo-client';
import { MutationSetBillingAddressArgs } from '~/typings/graphql';
import { CREATE_BILLING_ADDRESS } from './create-billing-address-queries';

export type CreateBillingAddressParams = {
  planId: number;
  addressInput: {
    addressVariables: {
      streetOne: string;
      streetTwo?: string;
      city: string;
      state: string;
      zipCode: string;
    };
  };
};

export type CreateBillingAddressResponse = {
  success: boolean;
};

export const createBillingAddress = async (
  params: CreateBillingAddressParams,
): Promise<CreateBillingAddressResponse | undefined> => {
  const { data } = await apolloClient.mutate<any, MutationSetBillingAddressArgs>({
    mutation: CREATE_BILLING_ADDRESS,
    variables: { input: params.addressInput, planId: params.planId },
  });
  return { success: !!data?.setBillingAddress.success };
};
